import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import components
import MealPlanner from './components/MealPlanner';
import ShoppingList from './components/ShoppingList';
import MealManager from './components/MealManager';
import SharedList from './components/SharedList';
import SimpleSharedList from './components/SimpleSharedList';
import ApiDebugView from './components/ApiDebugView';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
          <div className="container">
            <Link className="navbar-brand" to="/">Meal Planning App</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Meal Planner</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/shopping-list">Shopping List</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/shared-shopping">Shared Shopping List</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/meals">Manage Meals</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/debug">API Debug</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="container mt-4">
          <Routes>
            <Route path="/" element={<MealPlanner />} />
            <Route path="/shopping-list" element={<ShoppingList />} />
            <Route path="/meals" element={<MealManager />} />
            <Route path="/shared-list/:shareId" element={<SharedList />} />
            <Route path="/shared-shopping" element={<SimpleSharedList />} />
            <Route path="/debug" element={<ApiDebugView />} />
          </Routes>
        </div>
        
        <footer className="mt-5 py-3 text-center bg-light">
          <div className="container">
            <p className="mb-0">Meal Planning App for Couples</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
